import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <Link to='/' className='link'>
      <h1 className='text-center mt-3 mb-5'>stories</h1>
    </Link>
  );
};

export default Header;
